import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.scss";
import { KeycloakProvider } from "./KeycloakProvider";
import { CreateTrack } from "./pages/CreateTrack";
import { Dashboard } from "./pages/Dashboard";
import { Profile } from "./pages/Profile";
import { SessionOverview } from "./pages/SessionOverview";
import { TimeOverview } from "./pages/TimeOverview";
import { TrackOverview } from "./pages/TrackOverview";
// import { Community } from "./pages/Community";

const router = createBrowserRouter([
  {
    path: "/",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <Dashboard /> }],
  },
  {
    path: "/tracks",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <TrackOverview /> }],
  },
  {
    path: "/add",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <CreateTrack /> }],
  },
  {
    path: "/times",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <TimeOverview /> }],
  },
  {
    path: "/session",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <SessionOverview /> }],
  },
  {
    path: "/profile",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <Profile /> }],
  },
  {
    path: "/community",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <p>hidden</p> }],
  },
  {
    path: "/admin",
    lazy: async () => import("./components/PrivateLayout"),
    children: [{ index: true, element: <p>hidden</p> }],
  },
]);

const Router: React.FC = () => {
  return <RouterProvider router={router} />;
};

const App = () => {
  return (
    <KeycloakProvider>
      <ToastContainer />
      <Router />
    </KeycloakProvider>
  );
};

export default App;
